import { ADD_REVENUE } from '../type';


import axios from 'axios';
import { toast } from 'react-toastify';

import { addRevenue, fileAttachment } from '../../Component/Helpers/api';
import { param } from 'jquery';
import $ from 'jquery';
export const AddRevenue = (param, onClose) => {
  let authToken = JSON.parse(localStorage.getItem('headData'));

  return axios.post(addRevenue.data, param, {
    headers: {
      Authorization: authToken?.spintlyToken,
    },
  })
    .then(res => {
      console.log(res, "shdhsgdhsdghs")
      if (res.data.statusValue === 200) {
        onClose(true, 'Request is submitted successfully');
      }
    })
    .catch(() => {
      //toast.error('Unable to submit the request');
    });
};



